import { useTranslation } from 'react-i18next';
import { BreadcrumbsProps } from '../../components/common/breadcrumbs/Breadcrumbs';
import TitleWrapper from '../../components/wrappers/titleWrapper/TitleWrapper';
import useMobileAppVersion from '../../hooks/api/mobileAppVersion/useMobileAppVersion';
import useUpdateMobileAppVersion from '../../hooks/api/mobileAppVersion/useUpdateMobileAppVersion';
import UpdateMobileAppVersionForm from './components/UpdateMobileAppVersionForm';

const MobileAppVersionView = () => {
  const { t } = useTranslation();

  const { mobileAppVersion, isLoading } = useMobileAppVersion();

  const { updateMobileAppVersion } = useUpdateMobileAppVersion();

  const breadcrumbsProps: BreadcrumbsProps = {
    limit: 1,
  };

  return (
    <TitleWrapper title={t('mobileAppVersion.pageTitle')} breadcrumbsProps={breadcrumbsProps}>
      <div>
        {isLoading ? (
          <p>{t('loading')}</p>
        ) : mobileAppVersion ? (
          <UpdateMobileAppVersionForm
            currentVersion={mobileAppVersion.version}
            onSubmitForm={async ({ data }) => {
              await updateMobileAppVersion({ id: mobileAppVersion.id.toString(), data: { version: data.version } });
            }}
          />
        ) : (
          <p>{t('mobileAppVersion.noData')}</p>
        )}
      </div>
    </TitleWrapper>
  );
};

export default MobileAppVersionView;
